import { asyncToGenerator as _asyncToGenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
import { UnknownSourceError, FetchFailureError } from './errors.js';
import { fetch } from '../utils/functions.js';

var Type = {
  BABELFISK: "BABELFISK",
  CASINOSAGA: "CASINOSAGA"
};
var Fetcher = {
  [Type.BABELFISK]: function () {
    var _babelfiskFetch = _asyncToGenerator(function* (url, _ref) {
      var {
        keys,
        language,
        bucket
      } = _ref;
      return fetch(url, {
        body: JSON.stringify({
          filter: {
            keys,
            language_codes: language,
            bucket: bucket
          }
        }),
        headers: {
          "Accept": "application/vnd.casinosaga.v1",
          "Content-Type": "application/json"
        },
        method: "POST"
      });
    });

    function babelfiskFetch(_x, _x2) {
      return _babelfiskFetch.apply(this, arguments);
    }

    return babelfiskFetch;
  }(),
  [Type.CASINOSAGA]: function () {
    var _casinosagaFetch = _asyncToGenerator(function* (url, _ref2) {
      var {
        keys,
        language,
        bucket
      } = _ref2;
      return fetch(url, {
        body: JSON.stringify({
          keys,
          language,
          bucket
        }),
        headers: {
          "Accept": "application/vnd.casinosaga.v1",
          "Content-Type": "application/json"
        },
        method: "POST"
      });
    });

    function casinosagaFetch(_x3, _x4) {
      return _casinosagaFetch.apply(this, arguments);
    }

    return casinosagaFetch;
  }()
};
/**
 * Fetch give keys content for specified language
 *
 * @access private
 *
 * @param {string} url
 * @param {Object} params
 * @param {Array.<string>} params.keys
 * @param {string} params.language
 * @param {string} params.bucket
 *
 * @returns {Promise.<Object, *>}
 *
 * @throws {FetchFailureError} Throws on non-200 response
 */

function fetchTranslations(_x5, _x6, _x7) {
  return _fetchTranslations.apply(this, arguments);
}

function _fetchTranslations() {
  _fetchTranslations = _asyncToGenerator(function* (source, url, _ref3) {
    var {
      keys,
      language,
      bucket
    } = _ref3;
    var fetch = Fetcher[source];

    if (fetch == null) {
      throw new UnknownSourceError(source);
    }

    var response = yield fetch(url, {
      keys,
      language,
      bucket
    });

    if (response.status !== 200) {
      throw new FetchFailureError(response);
    }

    var {
      result
    } = yield response.json();
    return result;
  });
  return _fetchTranslations.apply(this, arguments);
}

export { Type, fetchTranslations };
